import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHandleOpenViewerClick } from "../../../media-viewer/mediaViewerRedux";
import { getDownloadFileName, getDownloadLink } from "../../../util/mediaUtil";
import { MediaContext } from "../../common/media-context";
import { useIsAdmin, useIsUserIAPManager } from "../../../auth/authUtils";

import CircularProgress from "@material-ui/core/CircularProgress";
import DownloadIcon from "@material-ui/icons/SaveAlt";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import OpenIcon from "@material-ui/icons/OpenInNewOutlined";
import Tooltip from "@material-ui/core/Tooltip";

import ContentMediaUpdateAction from "./ContentMediaUpdateAction";
import { anyTrue } from "../../../util/ext";

const useStyles = makeStyles(theme => ({
  wrapper: {
    // margin: theme.spacing(1),
    position: "relative",
  },

  loading: {
    position: "absolute",
    top: 2,
    left: 2,
    zIndex: 1,
  },
}));

const ContentMediaActions = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const isAdmin = useIsAdmin();
  const isIAPManager = useIsUserIAPManager();

  const { handleOpenViewerClick, isViewerLoading } = useHandleOpenViewerClick();

  return (
    <Grid container>
      {getDownloadLink(context.media) && (
        <Grid item>
          <Tooltip title="Download">
            <IconButton
              href={getDownloadLink(context.media)}
              target="_blank"
              download={getDownloadFileName(context.media)}
            >
              <DownloadIcon fontSize="large" />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
      <Grid item>
        <Tooltip title="View Media">
          <div className={classes.wrapper}>
            <IconButton onClick={() => handleOpenViewerClick(context.media)}>
              <OpenIcon fontSize="large" />
            </IconButton>
            {isViewerLoading && (
              <CircularProgress className={classes.loading} color="primary" />
            )}
          </div>
        </Tooltip>
      </Grid>

      {anyTrue([isAdmin, isIAPManager]) && (
        <Grid item>
          <ContentMediaUpdateAction media={context.media} />
        </Grid>
      )}
    </Grid>
  );
};

export default ContentMediaActions;
